import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign(Object.assign({}, getTestId('TabContainerWidget')), {
  tab: {
    All: [{
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/solution-1-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/solutions-1-001.png.png'
      },
      link: ''
    }, {
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/solution-2-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/solutions-2-001.png.png'
      },
      link: ''
    }, {
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/solution-3-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/solutions-3-001.png'
      },
      link: ''
    }, {
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/solution-4-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/solutions-4-001.png'
      },
      link: ''
    }],
    Industry: [{
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/industry-1-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/industry-1-001.png'
      },
      link: ''
    }, {
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/industry-2-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/industry-2-001.png'
      },
      link: ''
    }, {
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/industry-3-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/industry-3-001.png'
      },
      link: ''
    }, {
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/industry-4-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/industry-4-001.png'
      },
      link: ''
    }],
    Function: [{
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/solution-1-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/solutions-1-001.png.png'
      },
      link: ''
    }, {
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/solution-2-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/solutions-2-001.png.png'
      },
      link: ''
    }, {
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/industry-1-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/industry-1-001.png'
      },
      link: ''
    }, {
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/industry-2-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/industry-2-001.png'
      },
      link: ''
    }],
    'Use Case': [{
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/industry-3-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/industry-3-001.png'
      },
      link: ''
    }, {
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/industry-4-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/industry-4-001.png'
      },
      link: ''
    }, {
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/solution-3-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/solutions-3-001.png'
      },
      link: ''
    }, {
      web: {
        imageStyle: {
          width: 321,
          height: 401
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/desktop/solution-4-521.png'
      },
      mobile: {
        imageStyle: {
          width: 236,
          height: 361
        },
        url: 'https://assets.airtel.in/static-assets/b2b-demo/mweb/home/solutions-4-001.png'
      },
      link: ''
    }]
  },
  style: {
    paddingBottom: 100,
    paddingTop: 100
  },
  title: [{
    color: '#BD0000',
    text: 'Custom Solutions'
  }, {
    color: '#000',
    text: ',\n'
  }, {
    color: '#000',
    text: 'empowering your business journey'
  }],
  subtitle: 'With Spamshield, we ensure 98% successful blocking of spam messages sent impersonating your business and 100% secure, ISO and GDPR complaint solution.',
  subHeading: 'Usecases'
});